import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

interface Props {
    steps: string[];
    activeStep: number;
    onStepClick?: (step: number) => void;
}

export default function CustomStepper({
    steps,
    activeStep,
    onStepClick,
}: Props): JSX.Element {
    const progress =
        activeStep >= steps.length
            ? 100
            : (activeStep / (steps.length - 1)) * 100;

    return (
        <Box sx={{ mb: 4, maxWidth:'900px', mx:'auto' }}>
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'space-between',                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 20,
                        left: '8%',
                        right: '8%',
                        height: 4,
                        bgcolor: '#E5E7EB',
                        borderRadius: 999,
                    }}
                />

                <Box
                    sx={{
                        position: 'absolute',
                        top: 20,
                        left: '8%',
                        width: `${progress * 0.84}%`,
                        height: 4,
                        borderRadius: 999,
                        transition: 'all .5s ease',
                        background:
                            'linear-gradient(90deg,#2563EB,#7C3AED)',
                    }}
                />

                {steps.map((step, index) => {
                    const completed = index < activeStep;
                    const current = index === activeStep;

                    return (
                        <Box
                            key={step}
                            onClick={() => onStepClick?.(index)}
                            sx={{
                                zIndex: 2,
                                textAlign: 'center',
                                width: 120,
                                cursor: onStepClick ? 'pointer' : 'default',
                                transition: '.25s',
                                '&:hover': {
                                    transform: onStepClick
                                        ? 'translateY(-2px)'
                                        : 'none',
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    mx: 'auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: completed
                                        ? 'linear-gradient(135deg,#2563EB,#7C3AED)'
                                        : current
                                        ? '#2563EB'
                                        : '#D1D5DB',
                                    color: '#fff',
                                    fontWeight: 700,
                                    boxShadow: current
                                        ? '0 0 0 8px rgba(37,99,235,.15)'
                                        : 'none',
                                    transition: '.3s',
                                }}
                            >
                                {completed ? (
                                    <CheckCircleRoundedIcon />
                                ) : (
                                    index + 1
                                )}
                            </Box>

                            <Typography
                                variant="body2"
                                mt={1.5}
                                fontWeight={600}
                            >
                                {step}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}   